// Decompression utilities for handling gzipped WebSocket data
export async function decompressData(base64Data: string): Promise<any> {
  try {
    // Decode base64 to binary
    const binaryString = atob(base64Data);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    // Create a blob and use DecompressionStream API (modern browsers)
    const blob = new Blob([bytes]);
    const stream = blob.stream().pipeThrough(new DecompressionStream('gzip'));
    const decompressedBlob = await new Response(stream).blob();
    const text = await decompressedBlob.text();
    
    return JSON.parse(text);
  } catch (error) {
    console.error('Decompression error:', error);
    
    // Fallback: Try native browser fetch API decompression
    try {
      const response = await fetch(`data:application/gzip;base64,${base64Data}`);
      const text = await response.text();
      return JSON.parse(text);
    } catch (fallbackError) {
      console.error('Fallback decompression failed:', fallbackError);
      throw error;
    }
  }
}

// Calculate tile coordinates from lat/lng
export function latLngToTile(lat: number, lng: number, zoom: number): { x: number; y: number } {
  const n = Math.pow(2, zoom);
  const x = Math.floor((lng + 180) / 360 * n);
  const y = Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 
           1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * n);
  return { x, y };
}

// Get all tiles in viewport
export function getTilesInViewport(
  bounds: { north: number; south: number; east: number; west: number },
  zoom: number
): number[][] {
  const tiles: number[][] = [];
  
  const minTile = latLngToTile(bounds.south, bounds.west, zoom);
  const maxTile = latLngToTile(bounds.north, bounds.east, zoom);
  
  for (let x = minTile.x; x <= maxTile.x; x++) {
    for (let y = minTile.y; y <= maxTile.y; y++) {
      tiles.push([zoom, x, y]);
    }
  }
  
  return tiles;
}